import React from "react"
import { OrderLineInfoWrapper, OrderLineRow, ProductNameWrapper } from "../Shared.styled"
import Money from "../../Money"
import DineroFactory from "dinero.js"
import {
  DeliveryGiftCardProduct,
  RefundGiftCardProduct,
  ReleaseGiftCardProduct
} from "lib/types/generated/graphql-types"
import { ReactComponent as GiftIcon } from "images/icons/gift-card.svg"

type Props = {
  giftCardProduct: DeliveryGiftCardProduct | RefundGiftCardProduct | ReleaseGiftCardProduct
}

const OperationGiftCardProduct = ({ giftCardProduct }: Props) => {
  return (
    <OrderLineRow>
      <OrderLineInfoWrapper>
        <GiftIcon />
        <ProductNameWrapper>
          <b>Gift card</b>
          <Money
            amount={giftCardProduct?.priceAmount ?? 0}
            currencyUnit={giftCardProduct?.currencyCode as DineroFactory.Currency}
          />
        </ProductNameWrapper>
      </OrderLineInfoWrapper>
    </OrderLineRow>
  )
}

export default OperationGiftCardProduct
